"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AreaType = void 0;
var AreaType;
(function (AreaType) {
    AreaType[AreaType["Classroom"] = 0] = "Classroom";
    AreaType[AreaType["Kitchen"] = 1] = "Kitchen";
    AreaType[AreaType["Cafeteria"] = 2] = "Cafeteria";
    AreaType[AreaType["Lounge"] = 3] = "Lounge";
    AreaType[AreaType["Hallway"] = 4] = "Hallway";
    AreaType[AreaType["Home Economics"] = 5] = "Home Economics";
    AreaType[AreaType["Nurses Office"] = 6] = "Nurses Office";
    AreaType[AreaType["Gymnasium"] = 7] = "Gymnasium";
    AreaType[AreaType["Locker Room"] = 8] = "Locker Room";
    AreaType[AreaType["Concessions"] = 9] = "Concessions";
    AreaType[AreaType["Bathroom"] = 10] = "Bathroom";
    AreaType[AreaType["Outdoors"] = 11] = "Outdoors";
    AreaType[AreaType["Office"] = 12] = "Office";
    AreaType[AreaType["Auditorium"] = 13] = "Auditorium";
    AreaType[AreaType["Other"] = 14] = "Other";
})(AreaType = exports.AreaType || (exports.AreaType = {}));
//# sourceMappingURL=AreaType.js.map